import { createPayload } from 'optimistic/base'
import { sortByKey } from 'util/arrays'
import { optimisticUpdatedAt } from 'util/optimistic'

export const deletePayload = (
  state,
  ticketId,
  folderId,
  search,
  updatedAt = new Date()
) =>
  createPayload(
    state,
    ticketId,
    'delete',
    {
      deleted_at: updatedAt,
      state: 'closed',
      stateChangedAt: updatedAt,
    },
    [
      {
        change_type: 'Deleted',
        change: {
          type: 'Deleted',
          restored: false,
        },
      },
      {
        change_type: 'State',
        change: {
          type: 'State',
          state: 'closed',
        },
      },
    ],
    folderId,
    search
  )

// Returns the optimistic data for a bulk delete action.
export const bulkDeletePayload = (state, ticketIds, folderId, search) => {
  return sortByKey(
    ticketIds.map(id => {
      return deletePayload(state, id, folderId, search, optimisticUpdatedAt())
    }),
    'id'
  )
}
